import {ResponseMessageModel} from "./response-message.model";

export class UpdateStatusResponseModel extends ResponseMessageModel {
  code: string;
}
